import { Language } from "../Constants/LanguageConstants";
import settings from "../settings.json";

export interface ISettingsModel {
  defaultLanguage: string;
  documentUri: string;
  manifestPath: string;
}

export const SettingsModel: ISettingsModel = settings;

export const UpdateManifestPath = (lang: Language) => {
  SettingsModel.manifestPath = settings.manifestPath.replace("{lang}", lang);
};
